import { Button, Col, Row, Space, Switch } from "antd";
import React, { useEffect, useState } from "react";
import LabelText from "../../../../components/input/LabelText";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { startUpdateServicio } from "../../../../context/actions/concesionariosActions";

export const Anulado = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [newMotivoAnulado, setNewMotivoAnulado] = useState();

  const { anuladoGNP, motivoAnulado, contamosConVale } = useSelector(
    (state) => state.concesionariosReducer.concesionariosServicio
  );
  //
  useEffect(() => {
    setNewMotivoAnulado(motivoAnulado);
  }, [motivoAnulado]);



  const hanldeChange = (val, ele) =>
    dispatch(startUpdateServicio({ [ele]: val }, id));

  const handleClick = () =>
    dispatch(startUpdateServicio({ motivoAnulado: newMotivoAnulado }, id));

  ///
  return (
    <>
      <Row style={{ marginBottom: 10 }}>
        <Col>
          <Space direction="vertical">
            <Switch
              checked={anuladoGNP}
              onChange={(val)=> hanldeChange(val, "anuladoGNP")}
              checkedChildren="Si"
              unCheckedChildren="No"
            />
          </Space>
        </Col>
        <Col>
          <div className="label">Anulado</div>
        </Col>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col>
          <Space direction="vertical">
            <Switch
              checked={contamosConVale}
              onChange={(val)=> hanldeChange(val, "contamosConVale")}
              checkedChildren="Si"
              unCheckedChildren="No"
            />
          </Space>
        </Col>
        <Col>
          <div className="label">Contamos con Vale</div>
        </Col>
      </Row>
      {anuladoGNP === true && (
        <Row gutter={10}>
          <Col span={20}>
            <LabelText
              value={newMotivoAnulado}
              onChange={({ target }) => setNewMotivoAnulado(target.value)}
              size="small"
              label="motivo de anulación"
            />
          </Col>
          <Col span={4} style={{ paddingTop: 17 }}>
            <Button onClick={handleClick} size="small" danger>
              ok
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};
